const modulesConfig = {

  Master: {
    label: "Master",

    subFields: {

      Company: {
        label: "Company",
      },

      Account: {
        label: "Account",
      },

      Product: {
        label: "Product",
      },

      BankCashPosting: {
        label: "BankCash Posting",
      },

    },
  },

  Transaction: {
    label: "Transaction",

    subFields: {

      Quotation: {
        label: "Quotation",
      },

      // ❌ COMMENTED: Sale Order
      // SalesOrder: {
      //   label: "Sales Order",
      // },

      // ❌ COMMENTED: Proforma Invoice
      // ProformaInvoice: {
      //   label: "Proforma Invoice",
      // },

      SaleChallan: {
        label: "Sale Challan",
      },

      SaleInvoice: {
        label: "Sale Invoice",
      },

      CreditNote: {
        label: "Credit Note",
      },

      // ❌ COMMENTED: Purchase Order
      // PurchaseOrder: {
      //   label: "Purchase Order",
      // },

      // ❌ COMMENTED: Purchase Challan
      // PurchaseChallan: {
      //   label: "Purchase Challan",
      // },

      // ❌ COMMENTED: Purchase Invoice
      // PurchaseInvoice: {
      //   label: "Purchase Invoice",
      // },

      // ❌ COMMENTED: Debit Note
      // DebitNote: {
      //   label: "Debit Note",
      // },

      // ❌ COMMENTED: Receivable
      // Receivable: {
      //   label: "Receivable",
      // },

      // ❌ COMMENTED: Payable
      // Payable: {
      //   label: "Payable",
      // },

      // ❌ COMMENTED: General Voucher
      // JeneralVourcher: {
      //   label: "Jeneral Vourcher",
      // },

    },
  },

  Reports: {
    label: "Reports",

    subFields: {

      AccountReport: {
        label: "Account Reports",
      },

      OSandODBillsReport: {
        label: "OS Reports",
      },

      // ❌ COMMENTED: Stock Report
      // StockReport: {
      //   label: "Stock Report",
      // },

      // ❌ COMMENTED: MIS Sale
      // MisReport: {
      //   label: "MIS Sale",
      // },

      // ❌ COMMENTED: MIS Purchase
      // MisPurchaseReport: {
      //   label: "MIS Purchase",
      // },

      GSTReports: {
        label: "GST Reports",
      },

    },
  },

  Settings: {
    label: "Settings",

    subFields: {

      PrintingUtilities: {
        label: "Printing Utilities",
      },

      UserDefine: {
        label: "User Define",
      },

      Config: {
        label: "Config",
      },

    },
  },

  UserManagement: {
    label: "User Management",

    subFields: {

      UserMaster: {
        label: "User Master",
      },

    },
  },

};

export default modulesConfig;